"use strict";

exports.__esModule = true;
exports.getCategoryPostType = getCategoryPostType;

var _postTypes = require("../constants/post-types");

function getCategoryPostType(category) {
  var ALL = 'all';
  var format;

  if (category.postTypes.length) {
    format = category.postTypes.length > 1 ? ALL : category.postTypes.includes(_postTypes.QUESTION) ? _postTypes.QUESTION : _postTypes.DISCUSSION;
  } else {
    format = ALL;
  }

  return format;
}